// Main Entry Point for TradeOS Dashboard

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/animations.css';
import { initAnalytics } from './lib/analytics';
import { redirectRefreshToDashboard } from './lib/refreshRedirect';
import { initTheme } from './stores/themeStore';

// Normalize refreshed app routes before analytics and the router see them.
redirectRefreshToDashboard();

// Apply the persisted/system theme before React renders any route.
initTheme();

// Boot analytics before the React tree mounts.
// No-ops if VITE_POSTHOG_KEY is not set or VITE_POSTHOG_DISABLED=true.
initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.DEV ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
